import React from "react";
import ToggleSwitch from "../../../Forms/Input/ToggleSwitch";

interface ReportProfile {
  reportId: number;
  code: string;
  name: string;
  enabled: boolean;
}

interface ReportProfileTableRowProps {
  index: number;
  report: ReportProfile;
  onToggle: (report: ReportProfile) => void; // ✅ se pasa todo el objeto
}

/**
 * 🧱 Fila individual de reporte
 *
 * - Perfectamente alineada con el header.
 * - Sin label en el ToggleSwitch.
 * - Espaciado uniforme (px-6).
 */
const ReportProfileTableRow: React.FC<ReportProfileTableRowProps> = ({
  index,
  report,
  onToggle,
}) => {
  const isEnabled = report.enabled;

  return (
    <tr className="hover:bg-gray-50 dark:hover:bg-graydark/40 transition">
      {/* 🔢 Número */}
      <td className="w-20 text-center px-6 py-4 text-[15px] text-gray-900 dark:text-gray-200 border-b border-stroke dark:border-gray-700">
        {index + 1}
      </td>

      {/* 🧩 Código */}
      <td className="px-6 py-4 text-[15px] text-gray-900 dark:text-gray-200 border-b border-stroke dark:border-gray-700">
        {report.code}
      </td>

      {/* 📄 Nombre */}
      <td className="px-6 py-4 text-[15px] text-gray-900 dark:text-gray-200 border-b border-stroke dark:border-gray-700">
        {report.name}
      </td>

      {/* ⚙️ ToggleSwitch */}
      <td className="w-40 px-6 py-4 text-center border-b border-stroke dark:border-gray-700">
        <div className="flex items-center">
          <ToggleSwitch
            label=""
            name={`toggle-${report.reportId}`}
            checked={isEnabled}
            onChange={() => onToggle(report)} // ✅ pasa todo el objeto
          />
        </div>
      </td>
    </tr>
  );
};

export default ReportProfileTableRow;
